import { create } from "zustand";
import { getSupportUnreadCount } from "../../services/supportService";

// How many of the signed-in user's support tickets carry a reply they have not
// opened. Shared because two places move it: the sidebar badge reads and polls
// it, the thread page refreshes it right after marking a ticket read — so the
// badge clears the moment the reply is seen, not at the next poll.
//
// One request in flight at a time: the sidebar's focus and interval triggers
// and the thread's post-read refresh can coincide.
let inFlight = null;

const useSupportStore = create((set) => ({
  unreadCount: 0,
  refreshUnread: () => {
    if (inFlight) return inFlight;
    inFlight = getSupportUnreadCount()
      .then((data) => set({ unreadCount: Number(data?.count) || 0 }))
      .catch(() => {
        /* a badge is not worth an error toast; the next poll retries */
      })
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  },
  // Clear on sign-out (see useAuth.logoutUser): the count belongs to one user.
  reset: () => set({ unreadCount: 0 }),
}));

export default useSupportStore;
